export default class AjaxSearch extends HTMLInputElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents(){
        // Ferme la modale de recherche au click n'importe ou ailleurs
        window.addEventListener('click', function(e){   
            if (document.getElementById('closingElement').contains(e.target)){
                
            } else{
                $(".sv1").removeClass("show");
            }
        });

        // Lance la recherche ajax quand on tape 3+ caractères
        $(this).on("keyup", (e) => {
            if($(this).val().length >= 3) {
                $.ajax({
                    method: 'GET',
                    url: $(this).data('url'),
                    data: {
                      term: $(this).val(),
                      quickSearch: true,
                    },
                    success: function success(data) {
                        // Montre la modale et pousse le résultat
                        $(".sv1").addClass("show");
                        $(".sv1").html(data);
                    },
                });
            } else {
                // Cache la modale si on a moins de 3 caractères
                $(".sv1").removeClass("show");
            }
        });
    }
}